<script>
export default {
    props: {
        treatment: {
            type: Object,
            required: true,
        },
        showAppointments: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<template>
    <option :value="treatment.id">
        {{ treatment.start_date }} - {{ treatment.treatment_type_formatted}}
        <span v-if="showAppointments && treatment.number_treatments !== null">
            {{ trans('apps.treatments.treatments_left', { left: treatment.treatments_available, total: treatment.number_treatments }) }}
        </span>
    </option>
</template>

<style scoped>
</style>
